import { TObject } from "../../../common/TObject";
import { calculateGeometry } from "../../../common/GoogleObjects";
import { Drawing } from "../Drawing";
import { FeatureType } from "./Features";
import { Feature } from "./Feature";




export class GoogleFeature extends Feature {
    overlay: any;
    type: FeatureType = FeatureType.GOOGLE;


    constructor(parent: Drawing, overlay, readonly:boolean) {
        super(parent, readonly);

     
        this.setOverlay(overlay);
        this.editable(false);
        this.when('changed', () => {
            if (this.event('changed').enabled)
                this.parent.trigger('changed');


        });
        this.when('click', (e) => {        
            if (this.readonly) {
                return false;
            }
            this.debug('Click', e, this);
            this.parent.setSelection(this);
        });

    }

    getPosition() {
        if (!this.overlay) {
            return false;
        }
        return this.overlay.getPosition();
    }


    getId() {
        if (!this.overlay) {
            return false;
        }
        if (this.overlay.feature) {
            return this.overlay.feature.getId();
        }
        return false;
    }

    setPosition(latLng: google.maps.Data.Point) {
        if (!this.overlay) {
            console.error('GoogleFeature.setCenter: No overlay to set Center of');
        }

        this.overlay.set('position', latLng);
    }


    getLonLat() {

        //TODO: this is backwards and should be rewritten
        var vertices = [];
        if (!this.overlay.getPath) {
            switch (this.overlay.type) {
                case google.maps.drawing.OverlayType.RECTANGLE:
                    var b = this.overlay.getBounds();
                    vertices = [b.getSouthWest(), b.getNorthEast(), b.getSouthWest(), b.getNorthEast()];

                    break;
                default:
                    return super.getLonLat();
                    break;
            }
        } else {
            var path = this.overlay.getPath();
            for (var i = 0; i < path.getLength(); i++) {
                vertices.push(path.getAt(i));
            }
        }


        var bounds = new google.maps.LatLngBounds();
        var i: number;
        for (var i = 0; i < vertices.length; i++) {
             bounds.extend(vertices[i]);
        }
        var latLng = bounds.getCenter();
        return [latLng.lng(), latLng.lat()];
    }



    setOverlay(overlay) {
        this.overlay = overlay;
        if (this.overlay) {
            this.editable(this.editmode);
            this.addOverlayEvents();
            this.fixStroke();

            if (this.map) {
                this.overlay.setMap(this.map);
            }
        }

    }

    getLocationId() {
        if (this.overlay) {
            return this.overlay.get('locationId');
        }
        return super.getLocationId();;
    }


    setLocationId(locationId) {
        if (this.overlay) {
            this.overlay.set('locationId', locationId);
        }
        super.setLocationId(locationId);
        return this;
    }


    setMap(map) {
        super.setMap(map);
        if (this.overlay && this.map) {
            this.overlay.setMap(map);
        }
    }

    editable(editmode) {
        super.editable(editmode);

        if (this.overlay) {
            this.overlay.setOptions({
                draggable: editmode,
                editable: editmode,
                clickability: !this.readonly
            });
        }

    }

    delete() {
        super.delete();
        this.overlay.setMap(null);
        this.overlay = null;
    }


    fixStroke() {
        if (this.overlay.type == FeatureType.LABEL) {
            return false;
        }
        if (this.overlay.type == google.maps.drawing.OverlayType.POLYLINE) {
            this.overlay.set('strokeWeight', this.parent.polyLine.strokeWeight);
            this.overlay.set('strokeOpacity', this.parent.polyLine.strokeOpacity);
            this.overlay.set('fillOpacity', this.parent.polyLine.fillOpacity);
        } else {
            this.overlay.set('strokeWeight', this.parent.polyOptions.strokeWeight);
            this.overlay.set('strokeOpacity', this.parent.polyOptions.strokeOpacity);
            this.overlay.set('fillOpacity', this.parent.polyOptions.fillOpacity);
        }

        this.overlay.set('strokeColor', this.getcolor());
    }



    setColor(color) {
        if (this.getcolor() == color) {
            return this; //no change;
        }
        this.color = color;
        if (this.overlay.type == FeatureType.LABEL) {
            this.overlay.set('fontColor', color);
        } else
            if (this.overlay.type == google.maps.drawing.OverlayType.POLYLINE) {
                this.overlay.set('strokeColor', color);
            } else {
                this.overlay.set('fillColor', color);
                this.overlay.set('strokeColor', color);
            }

        if (this.overlay.feature) {

            if (this.overlay.feature.f) {
                this.overlay.feature.f.color = color;

            } else if (this.overlay.feature.l) {
                this.overlay.feature.l.color = color;

            } else {
               // console.error('No feature Color? ', this.overlay.feature);
            }

        }
        this.fixStroke();
        this.changed();
        return this;
    }

    getcolor() {
        if (!this.color)
            this.color = this.overlay.get('fillColor') || this.overlay.get('strokeColor');
        return this.color;

    }

    updateGeometry() {
        switch (this.overlay.type) {
            case google.maps.drawing.OverlayType.CIRCLE:
                this.overlay.feature.setProperty("radius", this.overlay.getRadius());
                break;
            default:
                this.overlay.feature.setGeometry(calculateGeometry(this.overlay, true));
        }
        this.changed();
        return this;
    }


    addOverlayEvents() {
         if (!this.overlay) {
            return false;
        }

        if (this.readonly) {
            return false;
        }

        switch (this.overlay.type) {
            case google.maps.drawing.OverlayType.POLYLINE:
                google.maps.event.addListener(this.overlay.getPath(), 'set_at', () => {
                    if (!this.overlay.drag) {
                        this.updateGeometry();
                    }
                });
                google.maps.event.addListener(this.overlay.getPath(), 'insert_at', () => {
                    this.updateGeometry();
                });
                google.maps.event.addListener(this.overlay.getPath(), 'remove_at', () => {
                    this.updateGeometry();
                });
                break;
            case google.maps.drawing.OverlayType.POLYGON:
                var paths = this.overlay.getPaths();
                for (var p = 0; p < paths.getLength(); p++)
                    for (var sp = 0; sp < paths.getAt(p).getLength(); sp++) {
                        google.maps.event.addListener(paths.getAt(p), 'set_at', () => {
                            if (!this.overlay.drag) {
                                this.updateGeometry();
                            }
                        });
                        google.maps.event.addListener(paths.getAt(p), 'insert_at', () => {
                            this.updateGeometry();
                        });
                        google.maps.event.addListener(paths.getAt(p), 'remove_at', () => {
                            this.updateGeometry();
                        });
                    }
                break;
            case google.maps.drawing.OverlayType.RECTANGLE:
                google.maps.event.addListener(this.overlay, 'bounds_changed', () => {
                    if (!this.overlay.drag) {
                        this.updateGeometry();
                    }
                });
                break;
            case google.maps.drawing.OverlayType.CIRCLE:
                google.maps.event.addListener(this.overlay, 'radius_changed', () => {
                    this.updateGeometry();
                });
                break;
            case FeatureType.LABEL:

                break;
            default:
                this.debug('Unknown overlay Type?? ', this.overlay.type);
        }




        google.maps.event.clearListeners(this.overlay, 'click');
        google.maps.event.addListener(this.overlay, "click", (e) => {
            /*    if (e)
                    e.preventDefault(); */
            this.debug(e);
            this.trigger('click', e);
            return false;
        });
        google.maps.event.addListener(this.overlay, "mouseover", (e) => {
            this.trigger('mouseover', e);
        });
        google.maps.event.addListener(this.overlay, "mousedown", (e) => {
            this.trigger('mousedown', e);
        });

        google.maps.event.addListener(this.overlay, 'dragstart', (e) => {
            this.overlay.drag = true;
        });
        google.maps.event.addListener(this.overlay, 'mouseup', (e) => {
            if (this.overlay.drag) {
                this.overlay.drag = false;
                this.updateGeometry();
            }
        });


        return this;
    }
}



